import { render, staticRenderFns } from "./ReportModule.vue?vue&type=template&id=f40a7d24&scoped=true&"
import script from "./ReportModule.vue?vue&type=script&lang=js&"
export * from "./ReportModule.vue?vue&type=script&lang=js&"
import style0 from "./ReportModule.vue?vue&type=style&index=0&id=f40a7d24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f40a7d24",
  null
  
)

component.options.__file = "ReportModule.vue"
export default component.exports